module.exports = __webpack_public_path__ + "img/icon-ivi.38d836c6.svg";